var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    fillRule: "evenodd",
    d: "m13.617 38.523.009.009.006.006a2.265 2.265 0 0 0 2.736 0l.006-.006.009-.009.036-.027q.29-.224.57-.459a47 47 0 0 0 6.138-6.246C26.43 27.705 30 21.765 30 15a15 15 0 0 0-30 0c0 6.765 3.57 12.705 6.876 16.791a47 47 0 0 0 6.138 6.246l.567.459zM15 19.5a4.501 4.501 0 0 0 1.722-8.657 4.501 4.501 0 0 0-4.904 7.339A4.5 4.5 0 0 0 15 19.5",
    clipRule: "evenodd"
  })));
};
export default SvgAddress;